/**
 * Locale-aware helpers for the Angular app.
 *
 * Mirrors the pattern in `src/angularjs/shared/utils/datetime.ts`
 * and reads the locale from `window.CareLineLive.js_locale`.
 */

/**
 * Whether the current locale uses US-style formatting.
 */
export function isUsLocale(): boolean {
    const locale = (window.CareLineLive?.js_locale ?? '').toLowerCase();

    return locale.startsWith('en-us');
}

/**
 * Luxon short-date format token for the current locale.
 * US: `'L/d/yyyy'` (M/D/YYYY), all others: `'d/L/yyyy'` (D/M/YYYY).
 */
export function shortDateFormat(): string {
    return isUsLocale() ? 'L/d/yyyy' : 'd/L/yyyy';
}

/**
 * First day of the week.
 * US: Sunday (7 in Luxon weekday), all others: Monday (1 in Luxon weekday).
 *
 * For Angular Material's DateAdapter (0-indexed, Monday = 0):
 * US: 6 (Sunday), all others: 0 (Monday).
 */
export function firstDayOfWeekLuxon(): number {
    return isUsLocale() ? 7 : 1;
}

/**
 * First day of the week for Angular Material's DateAdapter.
 * The adapter maps Luxon weekday (1-7) to 0-indexed (0-6) via `weekday - 1`.
 * US: 6 (Sunday), all others: 0 (Monday).
 */
export function firstDayOfWeekMaterial(): number {
    return isUsLocale() ? 6 : 0;
}
